// tslint:disable
import { PessoaBrowseComponent } from "..";

export class VendedorBrowseComponent {
  static pesquisa(sender: any, target: any, targetProp?: string) {
    if (targetProp == undefined) targetProp = "vendedor";
    PessoaBrowseComponent.pesquisa(sender, target, "Vendedor", targetProp);
  }
}
